import CampaignRemoteSource from './schema/CampaignRemoteSource';
import { CampaignEndSignal } from './schema/CampaignEndSignal';
import { makeBeaconCall, makeImpressionCall } from 'mini-iris-gateway';

/**
 * Class to instantiate a Iris Remote Source object
 */
class CampaignIrisRemoteSource implements CampaignRemoteSource {
    private beacon: string;
    private impression: string;

    public constructor(beacon: string, impression: string) {
        this.beacon = beacon;
        this.impression = impression;
    }

    public start(campaignId: string) {
        makeImpressionCall(this.impression, campaignId);
    }

    // This is required to be called to call the beacon URI with the right actionType
    public end(campaignId: string, endSignal: CampaignEndSignal) {
        makeBeaconCall(this.beacon, endSignal, campaignId);
    }
}

export default CampaignIrisRemoteSource;
